import { render, staticRenderFns } from "./stage-manage.vue?vue&type=template&id=35aa9cb4&scoped=true"
import script from "./stage-manage.vue?vue&type=script&lang=js"
export * from "./stage-manage.vue?vue&type=script&lang=js"
import style0 from "./stage-manage.vue?vue&type=style&index=0&id=35aa9cb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa9cb4",
  null
  
)

export default component.exports